import { runpodComplete, stripJsonFence } from './runpodClient';
import { buildExtractUserContent, EXTRACT_SYSTEM_PROMPT } from './llmPrompt';

export async function extractQuoteFromDocument({
  text,
  additionalNotes,
  previousDraft,
  userId = null,
  metadata = {},
}) {
  const user = buildExtractUserContent({ text, additionalNotes, previousDraft });
  const content = await runpodComplete({
    system: EXTRACT_SYSTEM_PROMPT,
    user,
    maxTokens: 4096,
    feature: 'import-document',
    userId,
    metadata,
  });

  const parsed = JSON.parse(stripJsonFence(content));
  if (!parsed || typeof parsed !== 'object') {
    throw new Error('Could not parse extracted quote JSON.');
  }
  return parsed;
}
